export default __webpack_public_path__ + "static/media/magic-wand-sparkles.22562c26.svg";